import React from "react";

import cn from "classnames";

import { boxForwardRef } from "../../../../../helpers/common/Box/Box";
import { Text } from "../../../../Text";

import type { BoxComponentWithDefault } from "../../../../../helpers/common/Box/Box";
import type { TextProps } from "../../../../Text";

import classes from "./ChipSuggestLabel.styl";

const CHIP_SUGGEST_LABEL_TEST_ID = "chip-suggest-label-test-id";

export type ChipLabel = Omit<
    TextProps,
    | "maxLines"
    | "textCase"
    | "underline"
    | "strikethrough"
    | "alignmentX"
    | "width"
    | "typographyStyle"
    | "lineHeight"
    | "truncateStyle"
>;

export const ChipLabel = boxForwardRef<
    BoxComponentWithDefault<"span", ChipLabel, "className">
>(({ customVarsStyles, children, ...props }, ref) =>
    children ? (
        <Text
            data-tsid={CHIP_SUGGEST_LABEL_TEST_ID}
            {...props}
            typographyStyle="caption-m"
            maxLines={1}
            customVarsStyles={cn(
                classes["custom-vars-styles"],
                customVarsStyles,
            )}
            ref={ref}
        >
            {children}
        </Text>
    ) : null,
);

ChipLabel.displayName = "ChipSuggest.Label";

export default ChipLabel;
